$(document).ready(function(){
 if(window.innerWidth > 980){
   let variantWrapperList = document.querySelectorAll('.bundle-product-list-wrapper .variant-wrapper .bundle-product-form-input');
      $('.bundle-product-list-wrapper .variant-wrapper .bundle-product-form-input').click(function(){
        let currentElement = $(this);
        console.log(currentElement, "currentElement")
        
          if(currentElement.hasClass('active')){
             currentElement.find('.variant-dropdown').removeClass('active');
             currentElement.parent().find('.bundle-product-form-input').removeClass('active');
          }else{
            currentElement.find('.variant-dropdown').addClass('active');
            currentElement.parent().find('.bundle-product-form-input').addClass('active');
          }
      });
    }
});

$("document").ready(function() {
  function updateUpsellPrices() {
    // $('[name="upsell_id"]').change(function(){
    $('[name="upsell_id"]').each(function () {
      let cur_id = $(this).attr('data-upsell');
      let cur_variant = $(this).val();
      let cur_handle = $(this).attr('data-handle');
  
      $('#total-bundle-msg').html('');
      jQuery.getJSON(window.Shopify.routes.root + 'products/'+cur_handle+'.js', function(product) {
        let variant = product.variants.filter(function(variant){
           return variant.id == cur_variant
        });
        
        if(variant.length != 0){
          // console.log(variant[0]);
          $('#product-select-'+cur_id).attr('data-available', variant[0].available);
          (variant[0].available)?$('#alert-msg-'+cur_id).html(''):$('#alert-msg-'+cur_id).html('<p class="upsell-error">Soldout</p>');
  
          if(variant[0].compare_at_price != null && variant[0].compare_at_price >= variant[0].price){
            $('#product-card-'+cur_id+' .price__sale .price-item--sale').text("₹"+parseFloat(variant[0].price/100).toFixed(2));
            $('#product-card-'+cur_id+' .price__sale .price-item--regular').text("₹"+parseFloat(variant[0].compare_at_price/100).toFixed(2)); 
            $('#product-card-'+cur_id+' .price.custom-price').addClass('price--on-sale');
            $('#product-select-'+cur_id).attr('data-price', variant[0].price);
            $('#product-select-'+cur_id).attr('data-stricke-price', variant[0].compare_at_price);
          } else {
            $('#product-card-'+cur_id+' .price__regular .price-item--regular').text("₹"+parseFloat(variant[0].price/100).toFixed(2));
            $('#product-card-'+cur_id+' .price.custom-price').removeClass('price--on-sale');
            $('#product-select-'+cur_id).attr('data-price', variant[0].price);
            $('#product-select-'+cur_id).attr('data-stricke-price', variant[0].price);
          }
        }
        
        let price_total = 0;
        let strickeout_total = 0;
        $('.bundle-products .bundle-product-card-wrapper [name="upsell_id"]').each(function() {
          let discount = Number($(this).attr('data-discount'));
          let price = Number($(this).attr('data-price'));
          let strickeout = Number($(this).attr('data-stricke-price'));
          if($(this).attr('data-available') == 'true'){
            price_total = price_total + price * ( discount / 100);
            strickeout_total = strickeout_total + strickeout;
          }
        });
        // $('.total-price').text("₹ "+Math.floor(price_total/100));
        // $('.strikeout-price').text("₹ "+Math.floor(strickeout_total/100));
        // $('.total-save-price').text("₹ "+Math.floor((strickeout_total - price_total)/100));
        $('.total-price').text("₹" + (price_total / 100).toFixed(2));
        $('.strikeout-price').text("₹" + (strickeout_total / 100).toFixed(2));
        $('.total-save-price').text("₹" + ((strickeout_total - price_total) / 100).toFixed(2));
  
        
      });
    });
  }

  // Run on page load
  $(document).ready(function () {
      updateUpsellPrices();
  });
  
  // Run when option changes
  $(document).on('change', '[name="upsell_id"]', function () {
      updateUpsellPrices();
  });

  

  // $(".bundle-atc-btn").on("click", function() {
  //   let dataApi = [];
  //   let formData = {};
  //   $('#total-bundle-msg').html('');
  //   $('.bundle-products .bundle-product-card-wrapper [name="upsell_id"]').each(function() {
  //   // $('.upsell-product .bundle-product-card-wrapper [name="upsell_id"]').each(function() {
  //     if($(this).attr('data-available') == 'true'){
  //       dataApi.push({'id': parseInt($(this).val()),'quantity': 1});
  //     }
  //   });
  //   console.log(formData, "formData")
  //     // For Default Cartdrawer
  //   let updateProOnCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  //   let sections = updateProOnCart.getSectionsToRender().map((section) => section.id);
  //   formData = {'items': dataApi, 'sections' : sections };
  //   // console.log('formData',formData)
  //   // formData = {'items': dataApi };
  //   if(dataApi.length > 0){
  //     let atc_btn = $(this);
  //     atc_btn.attr('disabled', true);
  //     atc_btn.addClass('loading');
  //     atc_btn.find('.loading__spinner').removeClass('hidden');
  //     console.log(atc_btn, "atc_btn")
  //     addItemToCartColection(formData, atc_btn);
  //   } else {
  //     $('#total-bundle-msg').html('<p class="bundle-error">Select Atlease One Product Variants.</p>');
  //   }
  // });


  $(".bundle-atc-btn").on("click", function () {
    let dataApi = [];
    let formData = {};
    let allValid = true; // Track if all variants are selected
    $('#total-bundle-msg').html('');

    $('.bundle-products .bundle-product-card-wrapper [name="upsell_id"]').each(function () {
      let $this = $(this);

      // Reset styles before validation
      if ($this.is('select')) {
        $this.removeClass("error-border");
      }

      // Case 1: Hidden input (default variant)
      if ($this.is('input[type="hidden"]') && $this.attr('data-available') == 'true') {
        dataApi.push({
          id: parseInt($this.val()),
          quantity: 1
        });
      }

      // Case 2: Select dropdown
      if ($this.is('select')) {
        let selectedVal = $this.val();
        if (selectedVal && !$this.find('option:selected').is('[disabled]')) {
          dataApi.push({
            id: parseInt(selectedVal),
            quantity: 1
          });
        } else {
          allValid = false;
          // Add red border highlight
          $this.addClass("error-border");
        }
      }
    });

    if (allValid && dataApi.length > 0) {
      // Proceed with ATC
      let updateProOnCart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      let sections = updateProOnCart
        .getSectionsToRender()
        .map((section) => section.id);
      formData = { items: dataApi, sections: sections };

      let atc_btn = $(this);
      atc_btn.attr("disabled", true);
      atc_btn.addClass("loading");
      atc_btn.find(".loading__spinner").removeClass("hidden");
      addItemToCartColection(formData, atc_btn);
    } else if (!allValid) {
      $('#total-bundle-msg').html('<p class="bundle-error">Please select all required options.</p>');
    }
  });

  // Validate all selects whenever a change happens
  $(document).on("change", '.bundle-products select[name="upsell_id"]', function () {
    let $this = $(this);

    // Recheck ALL selects to decide error message visibility
    let allValid = true;
    $('.bundle-products select[name="upsell_id"]').each(function () {
      let $select = $(this);
      if (!$select.val() || $select.find('option:selected').is('[disabled]')) {
        allValid = false;
        return false; // break loop
      }
    });

    if (allValid) {
      $('#total-bundle-msg').html('');
    } else {
      $('.bundle-products select[name="upsell_id"]').addClass("error-border");
      $('#total-bundle-msg').html('<p class="bundle-error">Please select all required options.</p>');
    }

    // Remove red border if current select is valid
    if ($this.val() && !$this.find('option:selected').is('[disabled]')) {
      $this.removeClass("error-border");
    }
  });


  $(".popup-btn").on("click", function() {
    // $('.upsell-product .popup-product').css('display', 'block');
    $('.upsell-popup-product.upsell-product').css('display', 'block');
  });

});

function addItemToCartColection(formData, atc_btn) {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    success: function(data, textStatus, xhr) {
      addToCartSuccess(data, textStatus, xhr);
      atc_btn.find('.loading__spinner').addClass('hidden');
      atc_btn.attr('disabled', false)
      atc_btn.removeClass('loading');
      document.dispatchEvent(new CustomEvent('bundle:upsell:cart'));
    },
    error: function(error) {
      addToCartFail(error);
      atc_btn.find('.loading__spinner').addClass('hidden');
      atc_btn.attr('disabled', false)
      atc_btn.removeClass('loading');
    }
  });
}
function addToCartSuccess(products, textstatus, msg) {
  if(msg.status == 200 && msg.statusText == "success"){
    $('#total-bundle-msg').html('<p class="bundle-success">Products added to cart.</p>');
      // For Default Cartdrawer
      let updateProOnCart = document.querySelector('cart-drawer');
      products['items'][0]['sections'] = products['sections'];
      updateProOnCart.renderContents(products['items'][0]);// Update Product in cart
      if (updateProOnCart && updateProOnCart.classList.contains('is-empty')) updateProOnCart.classList.remove('is-empty');

      // For Cartdrawer App 
      // window.SLIDECART_UPDATE();
      // window.SLIDECART_OPEN();
  }
}
function addToCartFail(products) {
  if(products.status == 422){
    $('#total-bundle-msg').html('<p class="bundle-error">'+products.responseJSON.description+'</p>');
  }
  if(products.status == 400){
    $('#total-bundle-msg').html('<p class="bundle-error">Select Atlease One Available Product Variants...</p>');
  }
}
// Collection Bundle addtocart End
